import axios from '@axios'

const getInitialState = () => ({
  configurations: [],
  filters: { storeId: null, skuId: null },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {},

  mutations: {
    SET_CONFIGURATIONS(state, configurations) {
      state.configurations = configurations
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, configurations } = getInitialState()
      state.filters = filters
      state.configurations = configurations
    },
  },

  actions: {
    async fetchConfigurations({ commit, state }) {
      const { data } = await axios.get('/api/skus/price-suggestion-configurations', {
        params: {
          storeId: state.filters.storeId,
          skuId: state.filters.skuId,
        },
      })

      commit('SET_CONFIGURATIONS', data)
    },

    async createConfiguration(context, payload) {
      const { data } = await axios.post('/api/skus/price-suggestion-configurations', payload)
      return data
    },

    async updateConfiguration(context, { id, payload }) {
      const { data } = await axios.put(`/api/skus/price-suggestion-configurations/${id}`, payload)
      return data
    },

    async deleteConfiguration(context, id) {
      const { data } = await axios.delete(`/api/skus/price-suggestion-configurations/${id}`)
      return data
    },

    resetFilters({ commit }) {
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
